import { useEffect, useState } from 'react'
import { getEffectiveTmdbApiKey, useUserSettings } from '../settings/useUserSettings'
import { fetchTrendingWeek, type TmdbSimilarTitle } from '../tmdb/tmdb'

/**
 * TMDB /trending/all/week. Runs in the user's browser using either the
 * user's TMDB key or, when they haven't supplied one, the developer-bundled
 * key baked into the PWA build. One fetch per mount — the trending list
 * changes server-side every few hours so a session-long cache is enough.
 */
export function useTrendingWeek(): { items: TmdbSimilarTitle[]; loading: boolean } {
  const { settings } = useUserSettings()
  const [items, setItems] = useState<TmdbSimilarTitle[]>([])
  const [loading, setLoading] = useState(false)

  const apiKey = getEffectiveTmdbApiKey(settings)
  const language = settings?.tmdbPreferredLanguage || 'en'

  useEffect(() => {
    if (!apiKey) return
    let cancelled = false
    setLoading(true)
    fetchTrendingWeek(apiKey, language).then((r) => {
      if (cancelled) return
      setItems(r)
      setLoading(false)
    })
    return () => {
      cancelled = true
    }
  }, [apiKey, language])

  return { items, loading }
}
